import * as user from './user'
import * as plans from './plans'
import * as servers from './servers'
import * as devices from './devices'
import * as peers from './peers'
import * as site from './site'

export const namespaced = true

export const modules = {
    user,
    plans,
    servers,
    devices,
    peers,
    site
}